/*
 * STS hero background video - Phase C4.2, 2026-08-07.
 *
 * Deliberately does NOT ship <source> elements in the HTML. The markup renders
 * the approved still only; this script attaches the sources after window load
 * and only when it is safe to do so. That keeps the hero image the LCP element
 * and stops the video competing for bandwidth during first paint.
 *
 * The video is decorative Class B media. If anything here bails out, the user
 * keeps the still and loses nothing - every exit path is silent by design.
 */
(function () {
  var REDUCE = '(prefers-reduced-motion: reduce)';

  function defer(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2500 });
    } else {
      setTimeout(fn, 1200);
    }
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia(REDUCE).matches;
  }

  /* Respect Save-Data and 2G. A 2 MB decorative loop is not worth it there. */
  function constrainedConnection() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    return c.saveData === true || /(^|-)2g$/.test(c.effectiveType || '');
  }

  function init() {
    var video = document.querySelector('.sts-hero__video');
    if (!video) return;

    /* Reduced motion: never attach a source, never autoplay. Poster stays. */
    if (prefersReduced() || constrainedConnection()) return;

    var started = false;

    function start() {
      if (started) return;
      started = true;

      var webm = video.getAttribute('data-src-webm');
      var mp4 = video.getAttribute('data-src-mp4');
      if (!webm && !mp4) return;

      if (webm) appendSource(webm, 'video/webm');
      if (mp4) appendSource(mp4, 'video/mp4');

      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );

      video.load();

      var played = video.play();
      if (played && typeof played.catch === 'function') {
        /* Autoplay refused (some mobile power-saving modes). Still wins. */
        played.catch(function () {});
      }
    }

    function appendSource(src, type) {
      var s = document.createElement('source');
      s.src = src;
      s.type = type;
      video.appendChild(s);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              defer(start);
              return;
            }
          }
        },
        { rootMargin: '200px' }
      );
      io.observe(video);
    } else {
      defer(start);
    }

    /* If the user switches reduced motion on mid-session, stop immediately. */
    if (window.matchMedia) {
      var mq = window.matchMedia(REDUCE);
      var onChange = function () {
        if (mq.matches) {
          video.pause();
          video.classList.remove('is-playing');
        } else if (started) {
          video.play().catch(function () {});
        }
      };
      if (mq.addEventListener) {
        mq.addEventListener('change', onChange);
      } else if (mq.addListener) {
        mq.addListener(onChange);
      }
    }
  }

  function boot() {
    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', init, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
